import { useEffect, useState } from 'react';
import { Box, Chip, Stack, Skeleton } from '@mui/material';
import { Icon } from '@ts/storybook';
import { Grid, Typography } from '@ts/storybook';
import MainCard from './MainCard';
import { IDataKPICard } from '@ts/ui-models';

interface KPICardProps {
  title?: string;
  variant?: 'filled' | 'outlined';
  loading?: boolean;
  //color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  withoutDifference?: boolean;
  withoutLabelDifference?: boolean;
  dataCard: IDataKPICard;
}

const KPICard = (props: KPICardProps) => {
  const { title, dataCard, loading, variant } = props;
  const [percentage, setPercentage] = useState(0);
  const [isLoss, setIsLoss] = useState(false);
  const colorKPI = percentage >= 0 ? 'success' : 'warning';

  function calculatePercentage(value: number, oldValue: number) {
    let percentage = 0;

    if (oldValue !== 0) {
      percentage = (value / oldValue) * 100 - 100;
    }

    if (percentage > 0) {
      return {
        percentage,
        status: 'positive',
      };
    } else if (percentage < 0) {
      return {
        percentage,
        status: 'negative',
      };
    } else if (oldValue === 0 && value !== 0) {
      return {
        percentage: value * 100,
        status: 'positive',
      };
    } else {
      return {
        percentage,
        status: 'equal',
      };
    }
  }

  useEffect(() => {
    if (dataCard) {
      const calc = calculatePercentage(dataCard.value || 0, dataCard.oldValue);
      setPercentage(calc.percentage);
      setIsLoss(calc.status === 'negative');
    }
  }, [dataCard]);

  if (loading)
    return (
      <MainCard contentSX={{ p: 2.25 }}>
        <Stack spacing={0.5}>
          <Grid container alignItems="center">
            <Grid>
              <Skeleton variant="rounded" width={60} height={25} />
            </Grid>
          </Grid>
          <Skeleton variant="rounded" height={30} sx={{ mb: 1.5 }} />
        </Stack>
      </MainCard>
    );

  return (
    <MainCard contentSX={{ p: 2.25 }}>
      <Stack spacing={0.5}>
        {title && <Typography variant="h6" color="primary" text={title} />}
        <Grid container alignItems="center">
          <Grid>
            <Typography variant="h6" color="inherit" text={dataCard.value && dataCard.value.toString()} />
          </Grid>
          {percentage !== undefined && !props.withoutDifference && (
            <Grid>
              <Chip
                variant={variant || 'filled'}
                color={colorKPI}
                icon={
                  <>
                    {!isLoss && <Icon icon="TrendingUp" style={{ fontSize: '1.5rem', color: 'inherit' }} />}
                    {isLoss && <Icon icon="TrendingDown" style={{ fontSize: '1.5rem', color: 'inherit' }} />}
                  </>
                }
                label={`${Math.round(percentage)}%`}
                sx={{ ml: 1.25, pl: 1, fontSize: 20 }}
                size="medium"
              />
            </Grid>
          )}
        </Grid>
      </Stack>
      {!props.withoutDifference && !props.withoutLabelDifference && (
        <Box sx={{ pt: 2 }}>
          <Typography
            variant="caption"
            color="textSecondary"
            text={[
              'Difference',
              ' ',
              <Typography
                component="span"
                variant="caption"
                sx={{ color: `${colorKPI || 'primary'}.main`, fontWeight: 'bold' }}
                text={dataCard.oldValue}
              />,
            ]}
          />
        </Box>
      )}
    </MainCard>
  );
};

/* KPICard.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.oneOf(['filled', 'outlined']),
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']),
  value: PropTypes.string,
  percentage: PropTypes.number,
  isLoss: PropTypes.bool,
  oldValue: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}; */

export default KPICard;
